export default __webpack_public_path__ + "static/media/labelIcon.9e3798b5.svg";